"use client";

import React from "react";
import { Facebook, Instagram, Mail, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="call-to-action" className="bg-[var(--color-dark-section)] py-24 px-6 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/20 blur-[120px] rounded-full pointer-events-none" />

      <div ref={ref} className={`max-w-4xl mx-auto text-center flex flex-col items-center relative z-10 transition-all duration-1000 ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="w-20 h-1.5 bg-accent mb-10 rounded-full" />

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-white mb-12 tracking-tight">
          Start Your Recovery Today
        </h2>

        <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 justify-center mb-12 w-full max-w-2xl">
          <a href="tel:+447463682889" className="group flex items-center justify-center gap-4 min-h-[3.5rem] px-8 rounded-xl bg-white/5 hover:bg-white/10 transition-all duration-300 border border-white/10 hover:border-accent/50 hover:shadow-[0_0_20px_rgba(45,212,191,0.15)] flex-1">
            <Phone className="w-6 h-6 text-accent group-hover:scale-110 transition-transform duration-300" />
            <span className="text-xl font-medium text-white tracking-wide">07463682889</span>
          </a>
          <a href="mailto:appointments@alignphysiotherapy.co.uk" className="group flex items-center justify-center gap-4 min-h-[3.5rem] px-8 rounded-xl bg-white/5 hover:bg-white/10 transition-all duration-300 border border-white/10 hover:border-accent/50 hover:shadow-[0_0_20px_rgba(45,212,191,0.15)] flex-1">
            <Mail className="w-6 h-6 text-accent group-hover:scale-110 transition-transform duration-300" />
            <span className="text-xl font-medium text-white tracking-wide">appointments@alignphysiotherapy.co.uk</span>
          </a>
        </div>

        <p className="text-xl md:text-2xl italic text-white/80 mb-14 font-serif max-w-2xl leading-relaxed">
          "You don’t have to live with pelvic health symptoms."
        </p>

        <div className="flex flex-col sm:flex-row gap-5 justify-center mb-20 w-full sm:w-auto">
          <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent-hover min-h-[3.5rem] px-10 text-lg rounded-xl transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_25px_rgba(45,212,191,0.25)] border-none">
            <Link to="https://align-physiotherapy.uk3.cliniko.com/bookings?business_id=1869864670421067946&practitioner_id=1869864668449745369&appointment_type_id=1869864670219741836">Book Online</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="border-2 border-white text-white bg-transparent hover:bg-white hover:text-[var(--color-dark-section)] min-h-[3.5rem] px-10 text-lg rounded-xl transition-all duration-300 hover:-translate-y-1">
            <Link to="#">Email Us</Link>
          </Button>
        </div>

        <div className="flex gap-8 justify-center items-center">
          <Link to="https://instagram.com" newTab className="text-accent hover:text-white transition-colors duration-300 p-3 rounded-full hover:bg-white/10" aria-label="Follow us on Instagram">
            <Instagram className="w-7 h-7" />
          </Link>
          <Link to="https://facebook.com" newTab className="text-accent hover:text-white transition-colors duration-300 p-3 rounded-full hover:bg-white/10" aria-label="Follow us on Facebook">
            <Facebook className="w-7 h-7" />
          </Link>
        </div>
      </div>
    </section>;
}